__webpack_require__.p = "/Border-Card-UI/";